import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { useTranslation } from "react-i18next";

export default function CurrentThdChart({ data }) {
  const { t } = useTranslation();
  // Backend'den gelen data: { THD_I1: 0.5, THD_I2: 0, THD_I3: null }
  const dataset = [
    { phase: t("chartLabels.I1"), value: data?.THD_I1 ?? null },
    { phase: t("chartLabels.I2"), value: data?.THD_I2 ?? null },
    { phase: t("chartLabels.I3"), value: data?.THD_I3 ?? null },
  ];

  return (
    <div>
      <h3 className="text-md font-semibold text-gray-700 mb-2">
        {t("currents.thdI")}
      </h3>
      <BarChart
        dataset={dataset}
        xAxis={[{ dataKey: "phase", label: t("chartLabels.phase") }]}
        yAxis={[{ min: 0, max: 100 }]}
        series={[
          {
            dataKey: "value",
            label: t("currents.thdI"),
            color: "#f97316", // turuncu ton → voltajdan farklı olsun diye
          },
        ]}
        height={300}
      />
    </div>
  );
}
